module.exports = __webpack_public_path__ + "static/media/APP_Scientist_152x174_4.52820b35.png";